export enum operationMarketType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export interface OperationMarkets {
  operationMarketType: operationMarketType;
  agentId: string;
}

export interface PhoneType {
  id: string;
  legacyId: number;
  name: string;
}

export interface TmTag {
  id?: string;
  value: string;
}
export interface Member {
  id: string;
  user_id: string;
  name: string;
  nickname: string;
  leader_nickname: string;
  image_url: string;
  role: string;
  market?: operationMarketType | string;
  userLabel?: string;
  operation_markets: OperationMarkets[];
  email: string;
  phone_ddi: string;
  phone_ddd: string;
  phone_number: string;
  phone_type: PhoneType;
  creci_validity: string;
  creci_status: boolean;
  sale: boolean;
  rent: boolean;
}

export interface Pagination {
  page_number: number;
  page_items: number;
}

export interface Sort {
  sort: string;
  sort_order: SORT_ENUM;
}

export interface ResponseOk {
  next_request: Pagination;
  previous_request: Pagination;
  payload: Member[];
}

export enum SORT_ENUM {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface GetMembers {
  page_number: number;
  page_items: number;
  sort?: string;
  sort_order?: SORT_ENUM;
  search_values: string;
}

export interface Autocomplete {
  max_results: number;
  search_value: string;
}

export interface Team {
  description: string;
  type: string;
  field: string;
  label: string;
}

export interface AutocompleteResponse {
  payload: Team[];
}

export interface TmItem {
  id: string;
  user_id?: string;
  name?: string;
  nickname?: string;
  userLabel?: string;
  type?: string;
  option?: string;
  select?: boolean;
}

export const TmSortProperties = {
  2: 'agent.nickname',
  4: 'market.type',
  5: 'creci.validity'
};
